import { render, staticRenderFns } from "./SerialPortServiceTrigger.vue?vue&type=template&id=9d9d218c&"
import script from "./SerialPortServiceTrigger.vue?vue&type=script&lang=js&"
export * from "./SerialPortServiceTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports